import React from 'react';

export default () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M8.98592 14.2676L15.7465 7.50704L14.6901 6.41549L8.98592 12.1197L6.30986 9.44366L5.25352 10.5L8.98592 14.2676ZM5.1831 5.21831C6.66197 3.73944 8.43427 3 10.5 3C12.5657 3 14.3263 3.73944 15.7817 5.21831C17.2606 6.67371 18 8.43427 18 10.5C18 12.5657 17.2606 14.338 15.7817 15.8169C14.3263 17.2723 12.5657 18 10.5 18C8.43427 18 6.66197 17.2723 5.1831 15.8169C3.7277 14.338 3 12.5657 3 10.5C3 8.43427 3.7277 6.67371 5.1831 5.21831Z" 
      // fill="#80C07B"
    />
  </svg>

)
